import { ToastContainer } from '../../components/Common';
import DealerInventoryPage from './page';

const DealerInventoryPageWrapper = () => {
	return (
		<>
			<div className="page-content">
				<DealerInventoryPage />
			</div>
			<ToastContainer />
		</>
	);
};

export default DealerInventoryPageWrapper;
